import { render, staticRenderFns } from "./paymentSandboxOrderManageList.vue?vue&type=template&id=b9de68de&scoped=true"
import script from "./paymentSandboxOrderManageList.vue?vue&type=script&lang=js"
export * from "./paymentSandboxOrderManageList.vue?vue&type=script&lang=js"
import style0 from "./paymentSandboxOrderManageList.vue?vue&type=style&index=0&id=b9de68de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9de68de",
  null
  
)

export default component.exports